import React from "react";
import DocumentationSidebar from "../component/DocumentationSidebar";
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function IntegrationDocumentation() {
  const { t } = useTranslation();
  const image001 = useDocImage('integration-img', 'int-img-1.png');
  const image002 = useDocImage('integration-img', 'int-img-2.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        {/* Integration Content */}
        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.integration.title')}</h1>
            <p className="header-para">
              {t('documentation.integration.intro')}
            </p>

            {/* Section 1: Accessing Integration */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.integration.accessingModule.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.accessingModule.steps.step1') }}></li>
                  <li>{t('documentation.integration.accessingModule.steps.step2')}</li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.accessingModule.steps.step3') }}></li>
                </ul>
                <img
                  src={image001}
                  alt={t('documentation.integration.accessingModule.imageAlt')}
                  className="img-fluid pt-20 pb-20"
                />
              </div>
            </div>

            {/* Section 2: Understanding the Listing Page */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.integration.listingPage.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.integration.listingPage.intro')}</p>
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.listingPage.columns.leadFormField') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.listingPage.columns.eloquaFormField') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.listingPage.columns.action') }}></li>
                </ul>

                <p className="mt-3" dangerouslySetInnerHTML={{ __html: t('documentation.integration.listingPage.statusTitle') }}></p>
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.listingPage.status.active') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.listingPage.status.inactive') }}></li>
                </ul>
              </div>
            </div>

            {/* Section 3: Eloqua Status Toggle */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.integration.toggleStatus.title')}
              </div>
              <div className="card-body">
                <p dangerouslySetInnerHTML={{ __html: t('documentation.integration.toggleStatus.intro') }}></p>
                <img
                  src={image002}
                  alt={t('documentation.integration.toggleStatus.imageAlt')}
                  className="img-fluid pt-20 pb-20"
                />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.toggleStatus.steps.step1') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.toggleStatus.steps.step2') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.toggleStatus.steps.step3') }}></li>
                </ul>
              </div>
            </div>

            {/* Section 4: Adding New Mapping */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.integration.addMapping.title')}
              </div>
              <div className="card-body">
                <p dangerouslySetInnerHTML={{ __html: t('documentation.integration.addMapping.intro') }}></p>
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.addMapping.steps.step1') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.addMapping.steps.step2') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.addMapping.steps.step3') }}></li>
                </ul>

                <div className="alert alert-info mt-3 mb-0" dangerouslySetInnerHTML={{ __html: t('documentation.integration.addMapping.note') }}></div>
              </div>
            </div>

            {/* Section 5: Deleting a Mapping */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.integration.deleteMapping.title')}
              </div>
              <div className="card-body">
                <p dangerouslySetInnerHTML={{ __html: t('documentation.integration.deleteMapping.intro') }}></p>
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.deleteMapping.steps.step1') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.deleteMapping.steps.step2') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.integration.deleteMapping.steps.step3') }}></li>
                </ul>
                <div className="alert alert-warning mt-3 mb-0" dangerouslySetInnerHTML={{ __html: t('documentation.integration.deleteMapping.warning') }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
